// extracted by mini-css-extract-plugin
export default {"reason":"ClaimOverview_reason__z3wjW","preview":"ClaimOverview_preview__RQ2vK","description":"ClaimOverview_description__SP8Om","image":"ClaimOverview_image__XbJBX"};